import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { VIDEO_SIZE, getImageSize } from '@core/helpers/getSlideSize';
import { MediaInfo } from '@core/models/media-info.model';

@Component({
  selector: 'app-gallery-video',
  templateUrl: './gallery-video.component.html',
  styleUrls: ['./gallery-video.component.scss']
})
export class GalleryVideoComponent implements OnInit, OnChanges {
  @Input() video: MediaInfo;
  @Input() index: number;
  @Input() play: boolean;
  @Output() handleSlideEvent = new EventEmitter<object>();

  width = getImageSize(VIDEO_SIZE).width;
  height = getImageSize(VIDEO_SIZE).height;
  isLoading = true;

  ngOnInit(): void {
    if (this.video) {
      this.handleSlideEvent.emit({ width: this.width, index: this.index });
    }
    if (this.play && this.index) {
      setTimeout(() => {
        const videoSlide: any = document.getElementById(`gallery-video-${this.index}`);
        this.playVideoSlide(videoSlide);
      }, 0);

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const videoSlide: any = document.getElementById(`gallery-video-${this.index}`);
    if (this.play) {
      this.playVideoSlide(videoSlide);
    } else {
      this.restartVideoSlide(videoSlide);
    }
  }


  private playVideoSlide(videoSlide) {
    if (videoSlide) {
      videoSlide.muted = true;
      videoSlide.loop = true;
      videoSlide.controls = true;
      this.isLoading = false;
      videoSlide.play();
    }
  }

  private restartVideoSlide(videoSlide) {
    if (videoSlide) {
      videoSlide.pause();
      videoSlide.currentTime = 0;
    }
  }

}
